import React, { ChangeEvent, HTMLAttributes, ReactNode } from "react";
import styled from "@emotion/styled";
import { HStack } from "./HStack";

interface BaseProps {
  index?: number | string;
  checked: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  label?: ReactNode;
  alignItem?: string;
  width?: string;
  fillColor?: string;
  size?: number;
}

type Props = BaseProps &
  Omit<HTMLAttributes<HTMLInputElement>, keyof BaseProps>;

export const Radio = ({
  index,
  checked,
  label,
  className = "body1 gray700",
  alignItem = "start",
  width,
  fillColor,
  size = 26,
  ...rest
}: Props) => {
  const id = `radio-${index ?? 0}`;

  return (
    <>
      <HiddenInput type="radio" checked={checked} id={id} {...rest} />
      <StyledLabel htmlFor={id}>
        <HStack gap={10} alignItems={alignItem}>
          <div
            style={{
              width: `${size}px`,
              height: `${size}px`,
              flexShrink: 0,
              display: "inline-block",
              lineHeight: 0,
            }}
          >
            {checked ? (
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: "block" }}
              >
                <circle
                  cx="13"
                  cy="13"
                  r="12.25"
                  fill="white"
                  stroke={fillColor}
                  strokeWidth="1.5"
                />
                <circle cx="13" cy="13" r="7" fill={fillColor} />
              </svg>
            ) : (
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: "block" }}
              >
                <circle
                  cx="13"
                  cy="13"
                  r="12.25"
                  fill="white"
                  stroke="#CCCCCC"
                  strokeWidth="1.5"
                />
              </svg>
            )}
          </div>
          <Label className={className} style={{ width: width }}>
            {label}
          </Label>
        </HStack>
      </StyledLabel>
    </>
  );
};

const HiddenInput = styled.input`
  display: none;
`;

const StyledLabel = styled.label`
  width: fit-content;

  cursor: pointer;
`;

const Label = styled.div`
  white-space: pre-line;
  width: 100%;
`;
